function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Muscles Icon");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "muscles-Web-store",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "muscles-Hyperice-product-landing-page---PayGo-user-logged-in---Desktop",
  transform: "translate(-772.000000, -1609.000000)",
  stroke: "currentcolor",
  strokeWidth: 1.17446809
}, /*#__PURE__*/React.createElement("g", {
  id: "muscles-EFFECTIVE-Copy",
  transform: "translate(-445.000000, 1371.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "muscles-Group",
  transform: "translate(1218.000000, 239.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.06382979,23.483798 C3.06382979,23.483798 3.7999933,23.2043664 4.32960733,22.8673419 C7.31557126,23.7479427 8.68762468,24 11.3988955,24 C15.1284375,24 20.578519,22.0454005 23.2498922,21.0581464 C24.3101795,18.49349 24.2377989,16.1254312 23.0874772,13.5949039 C21.1925182,9.42653732 16.4041012,3.79382094 13.881373,1.29528959 C13.0749473,0.496811872 12.3299569,0.0918848361 11.076184,0.0627329336 C9.82276409,0.0332255201 7.54895451,0.0332255201 6.76194805,0.00371810659 C5.97458852,-0.0254337959 5.01245636,0.0918848361 4.75012087,1.26613769 C4.48778539,2.44039054 4.07362721,4.22470028 3.95675905,4.958475 C3.84024396,5.69224972 4.13788705,5.99194549 5.52053275,6.49108295 C6.02084148,7.10753903 6.36438445,7.17259755 7.00557051,6.90809736 C7.64710964,6.64395268 10.23092,5.61048218 10.8138485,5.34633751 C11.3971301,5.08219283 11.7470284,4.49488865 11.7989306,3.87238888",
  id: "muscles-Stroke-462"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.2340426,5.10638298 C12.7346049,7.2092812 13.0712135,9.59302476 13.2765957,12.7659574",
  id: "muscles-Stroke-463"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,11.2340426 C2.17398948,11.3197721 3.75682173,11.7115746 5.33755519,13.1587632 C8.21393741,11.2132486 13.1985472,10.6131414 16.3404255,15.3191489",
  id: "muscles-Stroke-464"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.61702128,19.4042553 C7.73544948,21.1875391 12.3422681,21.6838902 15.3191489,19.4221565",
  id: "muscles-Stroke-465"
})))));

var SvgMuscles = function SvgMuscles(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMuscles, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/muscles.1a05c497.svg";
export { ForwardRef as ReactComponent };